import { mapState, mapActions } from 'pinia';
import { usePageStore } from '@/store';
import { dateFormat } from '../../common/format';
import register from '../../mixins/register';
import disclamerRegister from '../../mixins/disclaimer-register.js';
import { adNewPhoneValid } from '@/components/registerPhoneValidPop/index.js';
import { openLoginHideOtherPop } from '@/components/sign-log';
import { state as regState } from './register-track';
import { leadTypes } from '@/common/const.js'
import util from '@/common/util';
import { INTERCEPT_URL } from '@/common/customize';
import popMgr from '@/components/global/popMgr';
import agentLeadDialog from '@/components/sign-log/agent-lead-dialog.vue'
const HAS_STEP2_STYLE = [
    'fashion',
    'fashionNew',
    'standard',
    'standardNew',
    'classic',
    'classicNew',
    'broker',
    'brokerNew'
];
export default {
    mixins: [register, disclamerRegister],
    i18next: {
        ns: 'common'
    },
    inject: ['destroy'],
    props: {
        options: {
            type: Object,
            default: () => ({})
        },
        changeType: Function,
        changeAllowClose: Function
    },
    data: function() {
        return {
            step: 1,
            step1Data: {},
            submitDisabled: false,
            showNewRegister: false
        };
    },
    computed: {
        ...mapState(usePageStore, {
            wordPressSSR: store => store.page.wordPressSSR
        }),
        toastMsg() {
            return this.options.toast || '';
        },
        role() {
            return this.options.role || leadTypes.Buyer;
        },
        phoneRequired() {
            if (this.role === leadTypes.Buyer) {
                return this.options.ignoreBuyerPhone === undefined
                    ? !this.ignoreBuyerPhone
                    : !this.options.ignoreBuyerPhone;
            } else {
                return this.options.ignoreSellerPhone === undefined
                    ? !this.ignoreSellerPhone
                    : !this.options.ignoreSellerPhone;
            }
        },
        bgColor({ step, options }) {
            if (HAS_STEP2_STYLE.includes(options.style) && step === 2) {
                return options.backgroundColorTwo || '';
            } else {
                return options.backgroundColor || '';
            }
        },
        registerTitle() {
            if (this.options.registerTitle === undefined) {
                return this.$t('register.registerTitle');
            } else {
                return this.options.registerTitle;
            }
        },
        registerSubTitle() {
            if (this.options.registerSubTitle === undefined) {
                return this.$t('register.registerSubTitle', {
                    time: dateFormat('MMMM dd, yyyy', new Date(), this.$pinia)
                });
            } else {
                return this.options.registerSubTitle.replace(
                    /{currentDate}/g,
                    dateFormat('MMMM dd, yyyy', new Date(), this.$pinia)
                );
            }
        },
        registerTitleTwo() {
            if (this.options.registerTitleTwo === undefined) {
                return this.$t('register.registerTitleTwo');
            } else {
                return this.options.registerTitleTwo;
            }
        },
        registerSubTitleTwo() {
            if (this.options.registerSubTitleTwo === undefined) {
                return this.$t('register.registerSubTitleTwo');
            } else {
                return this.options.registerSubTitleTwo;
            }
        },
        optionsStep() {
            return this.options.step || 0;
        }
    },
    watch: {
        optionsStep(val) {
            if (val) {
                this.step = val;
            }
        }
    },
    created() {
        if (this.optionsStep) {
            this.step = this.optionsStep;
        }
    },
    mounted() {
        this.showNewRegister = adNewPhoneValid.showNewRegister();
    },
    methods: {
        ...mapActions(usePageStore, ['setCurrentUniqId']),
        emailSubmit(_form) {
            //TODO: @weizeng.shu  Subsequent burying function supplement
        },
        async emailSubmitSuccess(data = {}) {
            const agreeEle = this.$el.querySelector('[name="agree"]');
            if (agreeEle && !agreeEle.checked) {
                util.toast('Please select approval with the agreement');
                return false;
            }
            let isRAL = await this.hasRegisterAgentLead(data.email);
            if (isRAL) {
                popMgr.create(agentLeadDialog, {
                    isRegister: true,
                });
                return false;
            }
            data.canAssignToLender = true;
            data = { ...data, ...adNewPhoneValid.addAdNewRegisterParams() };
            this.step1Data = Object.assign({}, this.step1Data, data);
            if (this.autoRegisterInstance) {
                this.autoRegisterInstance.emit('emailLead-register');
            }
            this.step = 2;
            this.changeAllowClose && this.changeAllowClose(false);
            this.onTrack(this.regType.continue, regState.success);
        },
        emailSumbitError(_errorInfo) {
            this.onTrack(this.regType.continue, regState.fail);
        },
        registerNext() {
            if (this.inquiry && !this.showNewRegister) {
                this.onRegisterCallback(this.options.onregister, false);
                this.destroy();
                this.showQuestionnaire(
                    Object.assign({}, this.options.questionnaire || {}, {
                        noToast: true,
                        closeCallback: () => {
                            this.onSuccessCallback(this.options.onsuccess);
                        }
                    })
                );
            } else {
                this.onRegisterCallback(this.options.onregister, false);
                this.destroy();
                this.onSuccessCallback(this.options.onsuccess, !this.showNewRegister);
                adNewPhoneValid.openRegisterPhoneValidPop();
            }
        },
        registerSubmit(form, data) {
            console.log('sign-log registerSubmit===>>', form, data)
            this.setCurrentUniqId(
                INTERCEPT_URL.leadRegister,
                this.disclaimerUniqId
            );
            this.$EventBus.$emit('siteTrack', {
                ...Object.assign({}, this.step1Data, data),
                role: this.role,
                trackType: 'lead-register-submit',
                ele: this.$el
            });
        },
        registerSubmitSuccess(data = {}) {
            if (this.disclaimerSubmitDisabled) {
                return; 
            }
            this.submitDisabled = true;
            data = Object.assign(
                this.options.registerData || {},
                this.step1Data,
                data
            );
            data.flag = this.options.flag || 1;
            if (this.options.leadType) {
                data.leadType = this.options.leadType;
            }
            data = { ...data, ...adNewPhoneValid.addAdNewRegisterParams() };
            this.formatData(data, this.options.formatData);
            return this.leadRegister().finally(_ => {
                this.submitDisabled = false;
            });
        },
        hasUserCallBack(flag, error, value) {
            if (
                !flag && error?.code === 210003
            ) {
                setTimeout(() => {
                    openLoginHideOtherPop(this.options, value);
                }, 1000);
            }
        },
    }
};
